/**
 * Generated by orval 🍺
 * Do not edit manually.
 * RepeatMD.AdminApp, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import { useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AgelessLeadsProductOptionResponse,
  CheckServiceAreaByPostalCodeParams,
  DisplayAccessiblePracticesByEmailResponse,
  DisplayAgelessBookingCtaOfferResponse,
  DisplayAgelessFlowAccessForPlatformResponse,
  DisplayAgelessPlatformLocationsResponse,
  DisplayAgelessPracticeFinderLocationSearchResponse,
  DisplayAgelessPracticeFinderRankingResponse,
  DisplayEnabledAgelessFlowsForPlatformResponse,
  DisplayIsPlatformOnboardedForAgelessResponse,
  DisplayListPlatformInfos,
  DisplayNearestAgelessPlatformLocationResponse,
  DisplayPlatformTheme,
  DisplayPlatformWithSubdomain,
  DisplayPlatformsByApproxPlatformLocationResponse,
  DisplayServiceAreaCheckResponse,
  DisplaySuggestedSlugNamesForCompanyNameResponse,
  GetAgelessFlowAccessForPlatformParams,
  GetAgelessProductOptionsForPlatformParams,
  GetBookingCtaOfferBySubdomainParams,
  GetEnabledAgelessFlowsForPlatformParams,
  GetIsPlatformOnboardedForAgelessParams,
  GetNearestLocationForPlatformByCoordinatesParams,
  GetNearestLocationForPlatformByPostalCodeParams,
  GetPlatformBySubdomainParams,
  GetPlatformLocationsBySubdomainParams,
  GetPlatformThemeBySubdomainParams,
  GetPlatformsByApproxCoordinatesParams,
  GetPlatformsByApproxLocationParams,
  GetPracticeFinderLocationsByAddressParams,
  GetPracticeFinderLocationsByCoordinatesParams,
  GetPracticeFinderRankingsParams,
  GetSuggestedSlugsParams,
  ProblemDetails,
} from "../model";

import { retrieveData } from "../../custom-fetch";
import type { ErrorType } from "../../custom-fetch";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === "queryKey") continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetCompanyIdByCrmContactEmailUrl = (emailToSearch: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/companies/search/platform/${emailToSearch}`;
};

/**
 * @summary Retrieves platforms by CRM contact email.
 */
export const getCompanyIdByCrmContactEmail = async (
  emailToSearch: string,
  options?: Parameters<typeof retrieveData>[1],
): Promise<DisplayListPlatformInfos> => {
  return retrieveData<DisplayListPlatformInfos>(
    getGetCompanyIdByCrmContactEmailUrl(emailToSearch),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetCompanyIdByCrmContactEmailQueryKey = (emailToSearch: string) => {
  return [
    `https://admin.ageless.ai/api/v1/ageless/companies/search/platform/${emailToSearch}`,
  ] as const;
};

export const getGetCompanyIdByCrmContactEmailQueryOptions = <
  TData = Awaited<ReturnType<typeof getCompanyIdByCrmContactEmail>>,
  TError = ErrorType<unknown>,
>(
  emailToSearch: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCompanyIdByCrmContactEmail>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCompanyIdByCrmContactEmailQueryKey(emailToSearch);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompanyIdByCrmContactEmail>>> = ({
    signal,
  }) => getCompanyIdByCrmContactEmail(emailToSearch, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: emailToSearch !== null && emailToSearch !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getCompanyIdByCrmContactEmail>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetCompanyIdByCrmContactEmailQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCompanyIdByCrmContactEmail>>
>;
export type GetCompanyIdByCrmContactEmailQueryError = ErrorType<unknown>;

export function useGetCompanyIdByCrmContactEmail<
  TData = Awaited<ReturnType<typeof getCompanyIdByCrmContactEmail>>,
  TError = ErrorType<unknown>,
>(
  emailToSearch: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCompanyIdByCrmContactEmail>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyIdByCrmContactEmail>>,
          TError,
          Awaited<ReturnType<typeof getCompanyIdByCrmContactEmail>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCompanyIdByCrmContactEmail<
  TData = Awaited<ReturnType<typeof getCompanyIdByCrmContactEmail>>,
  TError = ErrorType<unknown>,
>(
  emailToSearch: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCompanyIdByCrmContactEmail>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompanyIdByCrmContactEmail>>,
          TError,
          Awaited<ReturnType<typeof getCompanyIdByCrmContactEmail>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCompanyIdByCrmContactEmail<
  TData = Awaited<ReturnType<typeof getCompanyIdByCrmContactEmail>>,
  TError = ErrorType<unknown>,
>(
  emailToSearch: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCompanyIdByCrmContactEmail>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves platforms by CRM contact email.
 */

export function useGetCompanyIdByCrmContactEmail<
  TData = Awaited<ReturnType<typeof getCompanyIdByCrmContactEmail>>,
  TError = ErrorType<unknown>,
>(
  emailToSearch: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCompanyIdByCrmContactEmail>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCompanyIdByCrmContactEmailQueryOptions(emailToSearch, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetAccessiblePracticesByEmailUrl = (emailToSearch: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/companies/search/practice/${emailToSearch}`;
};

/**
 * @summary Returns platforms accessible to the given admin email for signup matching.
 */
export const getAccessiblePracticesByEmail = async (
  emailToSearch: string,
  options?: Parameters<typeof retrieveData>[1],
): Promise<DisplayAccessiblePracticesByEmailResponse> => {
  return retrieveData<DisplayAccessiblePracticesByEmailResponse>(
    getGetAccessiblePracticesByEmailUrl(emailToSearch),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetAccessiblePracticesByEmailQueryKey = (emailToSearch: string) => {
  return [
    `https://admin.ageless.ai/api/v1/ageless/companies/search/practice/${emailToSearch}`,
  ] as const;
};

export const getGetAccessiblePracticesByEmailQueryOptions = <
  TData = Awaited<ReturnType<typeof getAccessiblePracticesByEmail>>,
  TError = ErrorType<unknown>,
>(
  emailToSearch: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAccessiblePracticesByEmail>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetAccessiblePracticesByEmailQueryKey(emailToSearch);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAccessiblePracticesByEmail>>> = ({
    signal,
  }) => getAccessiblePracticesByEmail(emailToSearch, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: emailToSearch !== null && emailToSearch !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof getAccessiblePracticesByEmail>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type GetAccessiblePracticesByEmailQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAccessiblePracticesByEmail>>
>;
export type GetAccessiblePracticesByEmailQueryError = ErrorType<unknown>;

export function useGetAccessiblePracticesByEmail<
  TData = Awaited<ReturnType<typeof getAccessiblePracticesByEmail>>,
  TError = ErrorType<unknown>,
>(
  emailToSearch: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAccessiblePracticesByEmail>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccessiblePracticesByEmail>>,
          TError,
          Awaited<ReturnType<typeof getAccessiblePracticesByEmail>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAccessiblePracticesByEmail<
  TData = Awaited<ReturnType<typeof getAccessiblePracticesByEmail>>,
  TError = ErrorType<unknown>,
>(
  emailToSearch: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAccessiblePracticesByEmail>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAccessiblePracticesByEmail>>,
          TError,
          Awaited<ReturnType<typeof getAccessiblePracticesByEmail>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAccessiblePracticesByEmail<
  TData = Awaited<ReturnType<typeof getAccessiblePracticesByEmail>>,
  TError = ErrorType<unknown>,
>(
  emailToSearch: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAccessiblePracticesByEmail>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Returns platforms accessible to the given admin email for signup matching.
 */

export function useGetAccessiblePracticesByEmail<
  TData = Awaited<ReturnType<typeof getAccessiblePracticesByEmail>>,
  TError = ErrorType<unknown>,
>(
  emailToSearch: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAccessiblePracticesByEmail>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAccessiblePracticesByEmailQueryOptions(emailToSearch, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetPlatformBySubdomainUrl = (params?: GetPlatformBySubdomainParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `https://admin.ageless.ai/api/v1/ageless/companies/search/platform/by-subdomain?${stringifiedParams}`
    : `https://admin.ageless.ai/api/v1/ageless/companies/search/platform/by-subdomain`;
};

/**
 * @summary Retrieves a platform by subdomain.
 */
export const getPlatformBySubdomain = async (
  params?: GetPlatformBySubdomainParams,
  options?: Parameters<typeof retrieveData>[1],
): Promise<DisplayPlatformWithSubdomain> => {
  return retrieveData<DisplayPlatformWithSubdomain>(getGetPlatformBySubdomainUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetPlatformBySubdomainQueryKey = (params?: GetPlatformBySubdomainParams) => {
  return [
    `https://admin.ageless.ai/api/v1/ageless/companies/search/platform/by-subdomain`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetPlatformBySubdomainQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlatformBySubdomain>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: GetPlatformBySubdomainParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPlatformBySubdomain>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPlatformBySubdomainQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformBySubdomain>>> = ({ signal }) =>
    getPlatformBySubdomain(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPlatformBySubdomain>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPlatformBySubdomainQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlatformBySubdomain>>
>;
export type GetPlatformBySubdomainQueryError = ErrorType<ProblemDetails>;

export function useGetPlatformBySubdomain<
  TData = Awaited<ReturnType<typeof getPlatformBySubdomain>>,
  TError = ErrorType<ProblemDetails>,
>(
  params: undefined | GetPlatformBySubdomainParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPlatformBySubdomain>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformBySubdomain>>,
          TError,
          Awaited<ReturnType<typeof getPlatformBySubdomain>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPlatformBySubdomain<
  TData = Awaited<ReturnType<typeof getPlatformBySubdomain>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: GetPlatformBySubdomainParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPlatformBySubdomain>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformBySubdomain>>,
          TError,
          Awaited<ReturnType<typeof getPlatformBySubdomain>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPlatformBySubdomain<
  TData = Awaited<ReturnType<typeof getPlatformBySubdomain>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: GetPlatformBySubdomainParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPlatformBySubdomain>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves a platform by subdomain.
 */

export function useGetPlatformBySubdomain<
  TData = Awaited<ReturnType<typeof getPlatformBySubdomain>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: GetPlatformBySubdomainParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPlatformBySubdomain>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPlatformBySubdomainQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetPlatformLocationsBySubdomainUrl = (
  params?: GetPlatformLocationsBySubdomainParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `https://admin.ageless.ai/api/v1/ageless/companies/search/platform/by-subdomain/locations?${stringifiedParams}`
    : `https://admin.ageless.ai/api/v1/ageless/companies/search/platform/by-subdomain/locations`;
};

/**
 * @summary Retrieves platform locations with operating hours by subdomain.
Public-facing, returns only information safe for anonymous consumers.
 */
export const getPlatformLocationsBySubdomain = async (
  params?: GetPlatformLocationsBySubdomainParams,
  options?: Parameters<typeof retrieveData>[1],
): Promise<DisplayAgelessPlatformLocationsResponse> => {
  return retrieveData<DisplayAgelessPlatformLocationsResponse>(
    getGetPlatformLocationsBySubdomainUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetPlatformLocationsBySubdomainQueryKey = (
  params?: GetPlatformLocationsBySubdomainParams,
) => {
  return [
    `https://admin.ageless.ai/api/v1/ageless/companies/search/platform/by-subdomain/locations`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetPlatformLocationsBySubdomainQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlatformLocationsBySubdomain>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: GetPlatformLocationsBySubdomainParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPlatformLocationsBySubdomain>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPlatformLocationsBySubdomainQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformLocationsBySubdomain>>> = ({
    signal,
  }) => getPlatformLocationsBySubdomain(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPlatformLocationsBySubdomain>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPlatformLocationsBySubdomainQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlatformLocationsBySubdomain>>
>;
export type GetPlatformLocationsBySubdomainQueryError = ErrorType<ProblemDetails>;

export function useGetPlatformLocationsBySubdomain<
  TData = Awaited<ReturnType<typeof getPlatformLocationsBySubdomain>>,
  TError = ErrorType<ProblemDetails>,
>(
  params: undefined | GetPlatformLocationsBySubdomainParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPlatformLocationsBySubdomain>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformLocationsBySubdomain>>,
          TError,
          Awaited<ReturnType<typeof getPlatformLocationsBySubdomain>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPlatformLocationsBySubdomain<
  TData = Awaited<ReturnType<typeof getPlatformLocationsBySubdomain>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: GetPlatformLocationsBySubdomainParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPlatformLocationsBySubdomain>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformLocationsBySubdomain>>,
          TError,
          Awaited<ReturnType<typeof getPlatformLocationsBySubdomain>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPlatformLocationsBySubdomain<
  TData = Awaited<ReturnType<typeof getPlatformLocationsBySubdomain>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: GetPlatformLocationsBySubdomainParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPlatformLocationsBySubdomain>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves platform locations with operating hours by subdomain.
Public-facing, returns only information safe for anonymous consumers.
 */

export function useGetPlatformLocationsBySubdomain<
  TData = Awaited<ReturnType<typeof getPlatformLocationsBySubdomain>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: GetPlatformLocationsBySubdomainParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPlatformLocationsBySubdomain>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPlatformLocationsBySubdomainQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetBookingCtaOfferBySubdomainUrl = (
  params?: GetBookingCtaOfferBySubdomainParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `https://admin.ageless.ai/api/v1/ageless/companies/search/platform/by-subdomain/booking-cta-offer?${stringifiedParams}`
    : `https://admin.ageless.ai/api/v1/ageless/companies/search/platform/by-subdomain/booking-cta-offer`;
};

/**
 * @summary Resolves the normalized booking CTA offer metadata for a platform by subdomain.
Public-facing, returns only anonymous-safe offer inputs for consumer CTA rendering.
 */
export const getBookingCtaOfferBySubdomain = async (
  params?: GetBookingCtaOfferBySubdomainParams,
  options?: Parameters<typeof retrieveData>[1],
): Promise<DisplayAgelessBookingCtaOfferResponse> => {
  return retrieveData<DisplayAgelessBookingCtaOfferResponse>(
    getGetBookingCtaOfferBySubdomainUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetBookingCtaOfferBySubdomainQueryKey = (
  params?: GetBookingCtaOfferBySubdomainParams,
) => {
  return [
    `https://admin.ageless.ai/api/v1/ageless/companies/search/platform/by-subdomain/booking-cta-offer`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetBookingCtaOfferBySubdomainQueryOptions = <
  TData = Awaited<ReturnType<typeof getBookingCtaOfferBySubdomain>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: GetBookingCtaOfferBySubdomainParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBookingCtaOfferBySubdomain>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetBookingCtaOfferBySubdomainQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getBookingCtaOfferBySubdomain>>> = ({
    signal,
  }) => getBookingCtaOfferBySubdomain(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getBookingCtaOfferBySubdomain>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetBookingCtaOfferBySubdomainQueryResult = NonNullable<
  Awaited<ReturnType<typeof getBookingCtaOfferBySubdomain>>
>;
export type GetBookingCtaOfferBySubdomainQueryError = ErrorType<ProblemDetails>;

export function useGetBookingCtaOfferBySubdomain<
  TData = Awaited<ReturnType<typeof getBookingCtaOfferBySubdomain>>,
  TError = ErrorType<ProblemDetails>,
>(
  params: undefined | GetBookingCtaOfferBySubdomainParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBookingCtaOfferBySubdomain>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBookingCtaOfferBySubdomain>>,
          TError,
          Awaited<ReturnType<typeof getBookingCtaOfferBySubdomain>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetBookingCtaOfferBySubdomain<
  TData = Awaited<ReturnType<typeof getBookingCtaOfferBySubdomain>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: GetBookingCtaOfferBySubdomainParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBookingCtaOfferBySubdomain>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getBookingCtaOfferBySubdomain>>,
          TError,
          Awaited<ReturnType<typeof getBookingCtaOfferBySubdomain>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetBookingCtaOfferBySubdomain<
  TData = Awaited<ReturnType<typeof getBookingCtaOfferBySubdomain>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: GetBookingCtaOfferBySubdomainParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBookingCtaOfferBySubdomain>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Resolves the normalized booking CTA offer metadata for a platform by subdomain.
Public-facing, returns only anonymous-safe offer inputs for consumer CTA rendering.
 */

export function useGetBookingCtaOfferBySubdomain<
  TData = Awaited<ReturnType<typeof getBookingCtaOfferBySubdomain>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: GetBookingCtaOfferBySubdomainParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getBookingCtaOfferBySubdomain>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetBookingCtaOfferBySubdomainQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetNearestLocationForPlatformByPostalCodeUrl = (
  platformId: string,
  params: GetNearestLocationForPlatformByPostalCodeParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `https://admin.ageless.ai/api/v1/ageless/companies/platforms/${platformId}/nearest-location?${stringifiedParams}`
    : `https://admin.ageless.ai/api/v1/ageless/companies/platforms/${platformId}/nearest-location`;
};

/**
 * @summary Finds the nearest active location for a platform from address input.
 */
export const getNearestLocationForPlatformByPostalCode = async (
  platformId: string,
  params: GetNearestLocationForPlatformByPostalCodeParams,
  options?: Parameters<typeof retrieveData>[1],
): Promise<DisplayNearestAgelessPlatformLocationResponse> => {
  return retrieveData<DisplayNearestAgelessPlatformLocationResponse>(
    getGetNearestLocationForPlatformByPostalCodeUrl(platformId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetNearestLocationForPlatformByPostalCodeQueryKey = (
  platformId: string,
  params?: GetNearestLocationForPlatformByPostalCodeParams,
) => {
  return [
    `https://admin.ageless.ai/api/v1/ageless/companies/platforms/${platformId}/nearest-location`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetNearestLocationForPlatformByPostalCodeQueryOptions = <
  TData = Awaited<ReturnType<typeof getNearestLocationForPlatformByPostalCode>>,
  TError = ErrorType<void | ProblemDetails>,
>(
  platformId: string,
  params: GetNearestLocationForPlatformByPostalCodeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNearestLocationForPlatformByPostalCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetNearestLocationForPlatformByPostalCodeQueryKey(platformId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getNearestLocationForPlatformByPostalCode>>
  > = ({ signal }) =>
    getNearestLocationForPlatformByPostalCode(platformId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: platformId !== null && platformId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getNearestLocationForPlatformByPostalCode>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetNearestLocationForPlatformByPostalCodeQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNearestLocationForPlatformByPostalCode>>
>;
export type GetNearestLocationForPlatformByPostalCodeQueryError = ErrorType<void | ProblemDetails>;

export function useGetNearestLocationForPlatformByPostalCode<
  TData = Awaited<ReturnType<typeof getNearestLocationForPlatformByPostalCode>>,
  TError = ErrorType<void | ProblemDetails>,
>(
  platformId: string,
  params: GetNearestLocationForPlatformByPostalCodeParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNearestLocationForPlatformByPostalCode>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNearestLocationForPlatformByPostalCode>>,
          TError,
          Awaited<ReturnType<typeof getNearestLocationForPlatformByPostalCode>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetNearestLocationForPlatformByPostalCode<
  TData = Awaited<ReturnType<typeof getNearestLocationForPlatformByPostalCode>>,
  TError = ErrorType<void | ProblemDetails>,
>(
  platformId: string,
  params: GetNearestLocationForPlatformByPostalCodeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNearestLocationForPlatformByPostalCode>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNearestLocationForPlatformByPostalCode>>,
          TError,
          Awaited<ReturnType<typeof getNearestLocationForPlatformByPostalCode>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetNearestLocationForPlatformByPostalCode<
  TData = Awaited<ReturnType<typeof getNearestLocationForPlatformByPostalCode>>,
  TError = ErrorType<void | ProblemDetails>,
>(
  platformId: string,
  params: GetNearestLocationForPlatformByPostalCodeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNearestLocationForPlatformByPostalCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Finds the nearest active location for a platform from address input.
 */

export function useGetNearestLocationForPlatformByPostalCode<
  TData = Awaited<ReturnType<typeof getNearestLocationForPlatformByPostalCode>>,
  TError = ErrorType<void | ProblemDetails>,
>(
  platformId: string,
  params: GetNearestLocationForPlatformByPostalCodeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNearestLocationForPlatformByPostalCode>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetNearestLocationForPlatformByPostalCodeQueryOptions(
    platformId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetNearestLocationForPlatformByCoordinatesUrl = (
  platformId: string,
  params?: GetNearestLocationForPlatformByCoordinatesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `https://admin.ageless.ai/api/v1/ageless/companies/platforms/${platformId}/nearest-location/by-coordinates?${stringifiedParams}`
    : `https://admin.ageless.ai/api/v1/ageless/companies/platforms/${platformId}/nearest-location/by-coordinates`;
};

/**
 * @summary Finds the nearest active location for a platform from geographic coordinates.
 */
export const getNearestLocationForPlatformByCoordinates = async (
  platformId: string,
  params?: GetNearestLocationForPlatformByCoordinatesParams,
  options?: Parameters<typeof retrieveData>[1],
): Promise<DisplayNearestAgelessPlatformLocationResponse> => {
  return retrieveData<DisplayNearestAgelessPlatformLocationResponse>(
    getGetNearestLocationForPlatformByCoordinatesUrl(platformId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetNearestLocationForPlatformByCoordinatesQueryKey = (
  platformId: string,
  params?: GetNearestLocationForPlatformByCoordinatesParams,
) => {
  return [
    `https://admin.ageless.ai/api/v1/ageless/companies/platforms/${platformId}/nearest-location/by-coordinates`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetNearestLocationForPlatformByCoordinatesQueryOptions = <
  TData = Awaited<ReturnType<typeof getNearestLocationForPlatformByCoordinates>>,
  TError = ErrorType<ProblemDetails>,
>(
  platformId: string,
  params?: GetNearestLocationForPlatformByCoordinatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNearestLocationForPlatformByCoordinates>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetNearestLocationForPlatformByCoordinatesQueryKey(platformId, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getNearestLocationForPlatformByCoordinates>>
  > = ({ signal }) =>
    getNearestLocationForPlatformByCoordinates(platformId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: platformId !== null && platformId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getNearestLocationForPlatformByCoordinates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetNearestLocationForPlatformByCoordinatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getNearestLocationForPlatformByCoordinates>>
>;
export type GetNearestLocationForPlatformByCoordinatesQueryError = ErrorType<ProblemDetails>;

export function useGetNearestLocationForPlatformByCoordinates<
  TData = Awaited<ReturnType<typeof getNearestLocationForPlatformByCoordinates>>,
  TError = ErrorType<ProblemDetails>,
>(
  platformId: string,
  params: undefined | GetNearestLocationForPlatformByCoordinatesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNearestLocationForPlatformByCoordinates>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNearestLocationForPlatformByCoordinates>>,
          TError,
          Awaited<ReturnType<typeof getNearestLocationForPlatformByCoordinates>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetNearestLocationForPlatformByCoordinates<
  TData = Awaited<ReturnType<typeof getNearestLocationForPlatformByCoordinates>>,
  TError = ErrorType<ProblemDetails>,
>(
  platformId: string,
  params?: GetNearestLocationForPlatformByCoordinatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNearestLocationForPlatformByCoordinates>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNearestLocationForPlatformByCoordinates>>,
          TError,
          Awaited<ReturnType<typeof getNearestLocationForPlatformByCoordinates>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetNearestLocationForPlatformByCoordinates<
  TData = Awaited<ReturnType<typeof getNearestLocationForPlatformByCoordinates>>,
  TError = ErrorType<ProblemDetails>,
>(
  platformId: string,
  params?: GetNearestLocationForPlatformByCoordinatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNearestLocationForPlatformByCoordinates>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Finds the nearest active location for a platform from geographic coordinates.
 */

export function useGetNearestLocationForPlatformByCoordinates<
  TData = Awaited<ReturnType<typeof getNearestLocationForPlatformByCoordinates>>,
  TError = ErrorType<ProblemDetails>,
>(
  platformId: string,
  params?: GetNearestLocationForPlatformByCoordinatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getNearestLocationForPlatformByCoordinates>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetNearestLocationForPlatformByCoordinatesQueryOptions(
    platformId,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getCheckServiceAreaByPostalCodeUrl = (
  platformId: string,
  params: CheckServiceAreaByPostalCodeParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `https://admin.ageless.ai/api/v1/ageless/companies/platforms/${platformId}/service-area-check?${stringifiedParams}`
    : `https://admin.ageless.ai/api/v1/ageless/companies/platforms/${platformId}/service-area-check`;
};

/**
 * @summary Checks whether a postal code is inside a platform's Ageless service area.
 */
export const checkServiceAreaByPostalCode = async (
  platformId: string,
  params: CheckServiceAreaByPostalCodeParams,
  options?: Parameters<typeof retrieveData>[1],
): Promise<DisplayServiceAreaCheckResponse> => {
  return retrieveData<DisplayServiceAreaCheckResponse>(
    getCheckServiceAreaByPostalCodeUrl(platformId, params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getCheckServiceAreaByPostalCodeQueryKey = (
  platformId: string,
  params?: CheckServiceAreaByPostalCodeParams,
) => {
  return [
    `https://admin.ageless.ai/api/v1/ageless/companies/platforms/${platformId}/service-area-check`,
    ...(params ? [params] : []),
  ] as const;
};

export const getCheckServiceAreaByPostalCodeQueryOptions = <
  TData = Awaited<ReturnType<typeof checkServiceAreaByPostalCode>>,
  TError = ErrorType<void>,
>(
  platformId: string,
  params: CheckServiceAreaByPostalCodeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof checkServiceAreaByPostalCode>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getCheckServiceAreaByPostalCodeQueryKey(platformId, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof checkServiceAreaByPostalCode>>> = ({
    signal,
  }) => checkServiceAreaByPostalCode(platformId, params, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: platformId !== null && platformId !== undefined,
    ...queryOptions,
  } as UseQueryOptions<Awaited<ReturnType<typeof checkServiceAreaByPostalCode>>, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };
};

export type CheckServiceAreaByPostalCodeQueryResult = NonNullable<
  Awaited<ReturnType<typeof checkServiceAreaByPostalCode>>
>;
export type CheckServiceAreaByPostalCodeQueryError = ErrorType<void>;

export function useCheckServiceAreaByPostalCode<
  TData = Awaited<ReturnType<typeof checkServiceAreaByPostalCode>>,
  TError = ErrorType<void>,
>(
  platformId: string,
  params: CheckServiceAreaByPostalCodeParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof checkServiceAreaByPostalCode>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkServiceAreaByPostalCode>>,
          TError,
          Awaited<ReturnType<typeof checkServiceAreaByPostalCode>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCheckServiceAreaByPostalCode<
  TData = Awaited<ReturnType<typeof checkServiceAreaByPostalCode>>,
  TError = ErrorType<void>,
>(
  platformId: string,
  params: CheckServiceAreaByPostalCodeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof checkServiceAreaByPostalCode>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof checkServiceAreaByPostalCode>>,
          TError,
          Awaited<ReturnType<typeof checkServiceAreaByPostalCode>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useCheckServiceAreaByPostalCode<
  TData = Awaited<ReturnType<typeof checkServiceAreaByPostalCode>>,
  TError = ErrorType<void>,
>(
  platformId: string,
  params: CheckServiceAreaByPostalCodeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof checkServiceAreaByPostalCode>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Checks whether a postal code is inside a platform's Ageless service area.
 */

export function useCheckServiceAreaByPostalCode<
  TData = Awaited<ReturnType<typeof checkServiceAreaByPostalCode>>,
  TError = ErrorType<void>,
>(
  platformId: string,
  params: CheckServiceAreaByPostalCodeParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof checkServiceAreaByPostalCode>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getCheckServiceAreaByPostalCodeQueryOptions(platformId, params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetActivePlatformsByCrmContactEmailUrl = (emailToSearch: string) => {
  return `https://admin.ageless.ai/api/v1/ageless/companies/search/platforms/${emailToSearch}/active`;
};

/**
 * @summary Retrieves active platforms by CRM contact email.
 */
export const getActivePlatformsByCrmContactEmail = async (
  emailToSearch: string,
  options?: Parameters<typeof retrieveData>[1],
): Promise<DisplayListPlatformInfos> => {
  return retrieveData<DisplayListPlatformInfos>(
    getGetActivePlatformsByCrmContactEmailUrl(emailToSearch),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetActivePlatformsByCrmContactEmailQueryKey = (emailToSearch: string) => {
  return [
    `https://admin.ageless.ai/api/v1/ageless/companies/search/platforms/${emailToSearch}/active`,
  ] as const;
};

export const getGetActivePlatformsByCrmContactEmailQueryOptions = <
  TData = Awaited<ReturnType<typeof getActivePlatformsByCrmContactEmail>>,
  TError = ErrorType<unknown>,
>(
  emailToSearch: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActivePlatformsByCrmContactEmail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetActivePlatformsByCrmContactEmailQueryKey(emailToSearch);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getActivePlatformsByCrmContactEmail>>> = ({
    signal,
  }) => getActivePlatformsByCrmContactEmail(emailToSearch, { signal, ...requestOptions });

  return {
    queryKey,
    queryFn,
    enabled: emailToSearch !== null && emailToSearch !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getActivePlatformsByCrmContactEmail>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetActivePlatformsByCrmContactEmailQueryResult = NonNullable<
  Awaited<ReturnType<typeof getActivePlatformsByCrmContactEmail>>
>;
export type GetActivePlatformsByCrmContactEmailQueryError = ErrorType<unknown>;

export function useGetActivePlatformsByCrmContactEmail<
  TData = Awaited<ReturnType<typeof getActivePlatformsByCrmContactEmail>>,
  TError = ErrorType<unknown>,
>(
  emailToSearch: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActivePlatformsByCrmContactEmail>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActivePlatformsByCrmContactEmail>>,
          TError,
          Awaited<ReturnType<typeof getActivePlatformsByCrmContactEmail>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetActivePlatformsByCrmContactEmail<
  TData = Awaited<ReturnType<typeof getActivePlatformsByCrmContactEmail>>,
  TError = ErrorType<unknown>,
>(
  emailToSearch: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActivePlatformsByCrmContactEmail>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActivePlatformsByCrmContactEmail>>,
          TError,
          Awaited<ReturnType<typeof getActivePlatformsByCrmContactEmail>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetActivePlatformsByCrmContactEmail<
  TData = Awaited<ReturnType<typeof getActivePlatformsByCrmContactEmail>>,
  TError = ErrorType<unknown>,
>(
  emailToSearch: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActivePlatformsByCrmContactEmail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves active platforms by CRM contact email.
 */

export function useGetActivePlatformsByCrmContactEmail<
  TData = Awaited<ReturnType<typeof getActivePlatformsByCrmContactEmail>>,
  TError = ErrorType<unknown>,
>(
  emailToSearch: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getActivePlatformsByCrmContactEmail>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetActivePlatformsByCrmContactEmailQueryOptions(emailToSearch, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetPlatformsByApproxLocationUrl = (params: GetPlatformsByApproxLocationParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `https://admin.ageless.ai/api/v1/ageless/companies/search/platforms/by-address?${stringifiedParams}`
    : `https://admin.ageless.ai/api/v1/ageless/companies/search/platforms/by-address`;
};

/**
 * @summary Retrieves platforms by approximate address location.
Uses geographic coordinates to find the nearest active platform locations.
 */
export const getPlatformsByApproxLocation = async (
  params: GetPlatformsByApproxLocationParams,
  options?: Parameters<typeof retrieveData>[1],
): Promise<DisplayPlatformsByApproxPlatformLocationResponse> => {
  return retrieveData<DisplayPlatformsByApproxPlatformLocationResponse>(
    getGetPlatformsByApproxLocationUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetPlatformsByApproxLocationQueryKey = (
  params?: GetPlatformsByApproxLocationParams,
) => {
  return [
    `https://admin.ageless.ai/api/v1/ageless/companies/search/platforms/by-address`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetPlatformsByApproxLocationQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlatformsByApproxLocation>>,
  TError = ErrorType<unknown>,
>(
  params: GetPlatformsByApproxLocationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPlatformsByApproxLocation>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPlatformsByApproxLocationQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformsByApproxLocation>>> = ({
    signal,
  }) => getPlatformsByApproxLocation(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPlatformsByApproxLocation>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPlatformsByApproxLocationQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlatformsByApproxLocation>>
>;
export type GetPlatformsByApproxLocationQueryError = ErrorType<unknown>;

export function useGetPlatformsByApproxLocation<
  TData = Awaited<ReturnType<typeof getPlatformsByApproxLocation>>,
  TError = ErrorType<unknown>,
>(
  params: GetPlatformsByApproxLocationParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPlatformsByApproxLocation>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformsByApproxLocation>>,
          TError,
          Awaited<ReturnType<typeof getPlatformsByApproxLocation>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPlatformsByApproxLocation<
  TData = Awaited<ReturnType<typeof getPlatformsByApproxLocation>>,
  TError = ErrorType<unknown>,
>(
  params: GetPlatformsByApproxLocationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPlatformsByApproxLocation>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformsByApproxLocation>>,
          TError,
          Awaited<ReturnType<typeof getPlatformsByApproxLocation>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPlatformsByApproxLocation<
  TData = Awaited<ReturnType<typeof getPlatformsByApproxLocation>>,
  TError = ErrorType<unknown>,
>(
  params: GetPlatformsByApproxLocationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPlatformsByApproxLocation>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves platforms by approximate address location.
Uses geographic coordinates to find the nearest active platform locations.
 */

export function useGetPlatformsByApproxLocation<
  TData = Awaited<ReturnType<typeof getPlatformsByApproxLocation>>,
  TError = ErrorType<unknown>,
>(
  params: GetPlatformsByApproxLocationParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPlatformsByApproxLocation>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPlatformsByApproxLocationQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetPlatformsByApproxCoordinatesUrl = (
  params?: GetPlatformsByApproxCoordinatesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `https://admin.ageless.ai/api/v1/ageless/companies/search/platforms/by-coordinates?${stringifiedParams}`
    : `https://admin.ageless.ai/api/v1/ageless/companies/search/platforms/by-coordinates`;
};

/**
 * @summary Retrieves platforms by approximate geographic coordinates.
 */
export const getPlatformsByApproxCoordinates = async (
  params?: GetPlatformsByApproxCoordinatesParams,
  options?: Parameters<typeof retrieveData>[1],
): Promise<DisplayPlatformsByApproxPlatformLocationResponse> => {
  return retrieveData<DisplayPlatformsByApproxPlatformLocationResponse>(
    getGetPlatformsByApproxCoordinatesUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetPlatformsByApproxCoordinatesQueryKey = (
  params?: GetPlatformsByApproxCoordinatesParams,
) => {
  return [
    `https://admin.ageless.ai/api/v1/ageless/companies/search/platforms/by-coordinates`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetPlatformsByApproxCoordinatesQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlatformsByApproxCoordinates>>,
  TError = ErrorType<unknown>,
>(
  params?: GetPlatformsByApproxCoordinatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPlatformsByApproxCoordinates>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPlatformsByApproxCoordinatesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformsByApproxCoordinates>>> = ({
    signal,
  }) => getPlatformsByApproxCoordinates(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPlatformsByApproxCoordinates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPlatformsByApproxCoordinatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlatformsByApproxCoordinates>>
>;
export type GetPlatformsByApproxCoordinatesQueryError = ErrorType<unknown>;

export function useGetPlatformsByApproxCoordinates<
  TData = Awaited<ReturnType<typeof getPlatformsByApproxCoordinates>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GetPlatformsByApproxCoordinatesParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPlatformsByApproxCoordinates>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformsByApproxCoordinates>>,
          TError,
          Awaited<ReturnType<typeof getPlatformsByApproxCoordinates>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPlatformsByApproxCoordinates<
  TData = Awaited<ReturnType<typeof getPlatformsByApproxCoordinates>>,
  TError = ErrorType<unknown>,
>(
  params?: GetPlatformsByApproxCoordinatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPlatformsByApproxCoordinates>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformsByApproxCoordinates>>,
          TError,
          Awaited<ReturnType<typeof getPlatformsByApproxCoordinates>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPlatformsByApproxCoordinates<
  TData = Awaited<ReturnType<typeof getPlatformsByApproxCoordinates>>,
  TError = ErrorType<unknown>,
>(
  params?: GetPlatformsByApproxCoordinatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPlatformsByApproxCoordinates>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves platforms by approximate geographic coordinates.
 */

export function useGetPlatformsByApproxCoordinates<
  TData = Awaited<ReturnType<typeof getPlatformsByApproxCoordinates>>,
  TError = ErrorType<unknown>,
>(
  params?: GetPlatformsByApproxCoordinatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPlatformsByApproxCoordinates>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPlatformsByApproxCoordinatesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetPracticeFinderLocationsByAddressUrl = (
  params: GetPracticeFinderLocationsByAddressParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `https://admin.ageless.ai/api/v1/ageless/companies/search/platform-locations/by-address?${stringifiedParams}`
    : `https://admin.ageless.ai/api/v1/ageless/companies/search/platform-locations/by-address`;
};

/**
 * @summary Retrieves active practice locations within a search radius for the practice finder.
 */
export const getPracticeFinderLocationsByAddress = async (
  params: GetPracticeFinderLocationsByAddressParams,
  options?: Parameters<typeof retrieveData>[1],
): Promise<DisplayAgelessPracticeFinderLocationSearchResponse> => {
  return retrieveData<DisplayAgelessPracticeFinderLocationSearchResponse>(
    getGetPracticeFinderLocationsByAddressUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetPracticeFinderLocationsByAddressQueryKey = (
  params?: GetPracticeFinderLocationsByAddressParams,
) => {
  return [
    `https://admin.ageless.ai/api/v1/ageless/companies/search/platform-locations/by-address`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetPracticeFinderLocationsByAddressQueryOptions = <
  TData = Awaited<ReturnType<typeof getPracticeFinderLocationsByAddress>>,
  TError = ErrorType<unknown>,
>(
  params: GetPracticeFinderLocationsByAddressParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPracticeFinderLocationsByAddress>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPracticeFinderLocationsByAddressQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPracticeFinderLocationsByAddress>>> = ({
    signal,
  }) => getPracticeFinderLocationsByAddress(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPracticeFinderLocationsByAddress>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPracticeFinderLocationsByAddressQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPracticeFinderLocationsByAddress>>
>;
export type GetPracticeFinderLocationsByAddressQueryError = ErrorType<unknown>;

export function useGetPracticeFinderLocationsByAddress<
  TData = Awaited<ReturnType<typeof getPracticeFinderLocationsByAddress>>,
  TError = ErrorType<unknown>,
>(
  params: GetPracticeFinderLocationsByAddressParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPracticeFinderLocationsByAddress>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPracticeFinderLocationsByAddress>>,
          TError,
          Awaited<ReturnType<typeof getPracticeFinderLocationsByAddress>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPracticeFinderLocationsByAddress<
  TData = Awaited<ReturnType<typeof getPracticeFinderLocationsByAddress>>,
  TError = ErrorType<unknown>,
>(
  params: GetPracticeFinderLocationsByAddressParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPracticeFinderLocationsByAddress>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPracticeFinderLocationsByAddress>>,
          TError,
          Awaited<ReturnType<typeof getPracticeFinderLocationsByAddress>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPracticeFinderLocationsByAddress<
  TData = Awaited<ReturnType<typeof getPracticeFinderLocationsByAddress>>,
  TError = ErrorType<unknown>,
>(
  params: GetPracticeFinderLocationsByAddressParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPracticeFinderLocationsByAddress>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves active practice locations within a search radius for the practice finder.
 */

export function useGetPracticeFinderLocationsByAddress<
  TData = Awaited<ReturnType<typeof getPracticeFinderLocationsByAddress>>,
  TError = ErrorType<unknown>,
>(
  params: GetPracticeFinderLocationsByAddressParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPracticeFinderLocationsByAddress>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPracticeFinderLocationsByAddressQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetPracticeFinderLocationsByCoordinatesUrl = (
  params?: GetPracticeFinderLocationsByCoordinatesParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `https://admin.ageless.ai/api/v1/ageless/companies/search/platform-locations/by-coordinates?${stringifiedParams}`
    : `https://admin.ageless.ai/api/v1/ageless/companies/search/platform-locations/by-coordinates`;
};

/**
 * @summary Retrieves active practice locations within a search radius for the practice finder.
 */
export const getPracticeFinderLocationsByCoordinates = async (
  params?: GetPracticeFinderLocationsByCoordinatesParams,
  options?: Parameters<typeof retrieveData>[1],
): Promise<DisplayAgelessPracticeFinderLocationSearchResponse> => {
  return retrieveData<DisplayAgelessPracticeFinderLocationSearchResponse>(
    getGetPracticeFinderLocationsByCoordinatesUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetPracticeFinderLocationsByCoordinatesQueryKey = (
  params?: GetPracticeFinderLocationsByCoordinatesParams,
) => {
  return [
    `https://admin.ageless.ai/api/v1/ageless/companies/search/platform-locations/by-coordinates`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetPracticeFinderLocationsByCoordinatesQueryOptions = <
  TData = Awaited<ReturnType<typeof getPracticeFinderLocationsByCoordinates>>,
  TError = ErrorType<unknown>,
>(
  params?: GetPracticeFinderLocationsByCoordinatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPracticeFinderLocationsByCoordinates>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetPracticeFinderLocationsByCoordinatesQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getPracticeFinderLocationsByCoordinates>>
  > = ({ signal }) =>
    getPracticeFinderLocationsByCoordinates(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPracticeFinderLocationsByCoordinates>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPracticeFinderLocationsByCoordinatesQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPracticeFinderLocationsByCoordinates>>
>;
export type GetPracticeFinderLocationsByCoordinatesQueryError = ErrorType<unknown>;

export function useGetPracticeFinderLocationsByCoordinates<
  TData = Awaited<ReturnType<typeof getPracticeFinderLocationsByCoordinates>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GetPracticeFinderLocationsByCoordinatesParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPracticeFinderLocationsByCoordinates>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPracticeFinderLocationsByCoordinates>>,
          TError,
          Awaited<ReturnType<typeof getPracticeFinderLocationsByCoordinates>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPracticeFinderLocationsByCoordinates<
  TData = Awaited<ReturnType<typeof getPracticeFinderLocationsByCoordinates>>,
  TError = ErrorType<unknown>,
>(
  params?: GetPracticeFinderLocationsByCoordinatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPracticeFinderLocationsByCoordinates>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPracticeFinderLocationsByCoordinates>>,
          TError,
          Awaited<ReturnType<typeof getPracticeFinderLocationsByCoordinates>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPracticeFinderLocationsByCoordinates<
  TData = Awaited<ReturnType<typeof getPracticeFinderLocationsByCoordinates>>,
  TError = ErrorType<unknown>,
>(
  params?: GetPracticeFinderLocationsByCoordinatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPracticeFinderLocationsByCoordinates>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves active practice locations within a search radius for the practice finder.
 */

export function useGetPracticeFinderLocationsByCoordinates<
  TData = Awaited<ReturnType<typeof getPracticeFinderLocationsByCoordinates>>,
  TError = ErrorType<unknown>,
>(
  params?: GetPracticeFinderLocationsByCoordinatesParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getPracticeFinderLocationsByCoordinates>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPracticeFinderLocationsByCoordinatesQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetPracticeFinderRankingsUrl = (params?: GetPracticeFinderRankingsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["platformIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? "null" : String(v));
      });
      return;
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `https://admin.ageless.ai/api/v1/ageless/companies/search/platforms/practice-finder-rankings?${stringifiedParams}`
    : `https://admin.ageless.ai/api/v1/ageless/companies/search/platforms/practice-finder-rankings`;
};

/**
 * @summary Returns practice finder ranking metadata for platform candidates.
 */
export const getPracticeFinderRankings = async (
  params?: GetPracticeFinderRankingsParams,
  options?: Parameters<typeof retrieveData>[1],
): Promise<DisplayAgelessPracticeFinderRankingResponse> => {
  return retrieveData<DisplayAgelessPracticeFinderRankingResponse>(
    getGetPracticeFinderRankingsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetPracticeFinderRankingsQueryKey = (params?: GetPracticeFinderRankingsParams) => {
  return [
    `https://admin.ageless.ai/api/v1/ageless/companies/search/platforms/practice-finder-rankings`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetPracticeFinderRankingsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPracticeFinderRankings>>,
  TError = ErrorType<unknown>,
>(
  params?: GetPracticeFinderRankingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPracticeFinderRankings>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPracticeFinderRankingsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPracticeFinderRankings>>> = ({
    signal,
  }) => getPracticeFinderRankings(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPracticeFinderRankings>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPracticeFinderRankingsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPracticeFinderRankings>>
>;
export type GetPracticeFinderRankingsQueryError = ErrorType<unknown>;

export function useGetPracticeFinderRankings<
  TData = Awaited<ReturnType<typeof getPracticeFinderRankings>>,
  TError = ErrorType<unknown>,
>(
  params: undefined | GetPracticeFinderRankingsParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPracticeFinderRankings>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPracticeFinderRankings>>,
          TError,
          Awaited<ReturnType<typeof getPracticeFinderRankings>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPracticeFinderRankings<
  TData = Awaited<ReturnType<typeof getPracticeFinderRankings>>,
  TError = ErrorType<unknown>,
>(
  params?: GetPracticeFinderRankingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPracticeFinderRankings>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPracticeFinderRankings>>,
          TError,
          Awaited<ReturnType<typeof getPracticeFinderRankings>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPracticeFinderRankings<
  TData = Awaited<ReturnType<typeof getPracticeFinderRankings>>,
  TError = ErrorType<unknown>,
>(
  params?: GetPracticeFinderRankingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPracticeFinderRankings>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Returns practice finder ranking metadata for platform candidates.
 */

export function useGetPracticeFinderRankings<
  TData = Awaited<ReturnType<typeof getPracticeFinderRankings>>,
  TError = ErrorType<unknown>,
>(
  params?: GetPracticeFinderRankingsParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPracticeFinderRankings>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPracticeFinderRankingsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetSuggestedSlugsUrl = (params: GetSuggestedSlugsParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `https://admin.ageless.ai/api/v1/ageless/companies/slug-suggestions?${stringifiedParams}`
    : `https://admin.ageless.ai/api/v1/ageless/companies/slug-suggestions`;
};

/**
 * @summary Suggests slug names for a company/practice name.
 */
export const getSuggestedSlugs = async (
  params: GetSuggestedSlugsParams,
  options?: Parameters<typeof retrieveData>[1],
): Promise<DisplaySuggestedSlugNamesForCompanyNameResponse> => {
  return retrieveData<DisplaySuggestedSlugNamesForCompanyNameResponse>(
    getGetSuggestedSlugsUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetSuggestedSlugsQueryKey = (params?: GetSuggestedSlugsParams) => {
  return [
    `https://admin.ageless.ai/api/v1/ageless/companies/slug-suggestions`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetSuggestedSlugsQueryOptions = <
  TData = Awaited<ReturnType<typeof getSuggestedSlugs>>,
  TError = ErrorType<unknown>,
>(
  params: GetSuggestedSlugsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuggestedSlugs>>, TError, TData>>;
    request?: SecondParameter<typeof retrieveData>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetSuggestedSlugsQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSuggestedSlugs>>> = ({ signal }) =>
    getSuggestedSlugs(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSuggestedSlugs>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSuggestedSlugsQueryResult = NonNullable<
  Awaited<ReturnType<typeof getSuggestedSlugs>>
>;
export type GetSuggestedSlugsQueryError = ErrorType<unknown>;

export function useGetSuggestedSlugs<
  TData = Awaited<ReturnType<typeof getSuggestedSlugs>>,
  TError = ErrorType<unknown>,
>(
  params: GetSuggestedSlugsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuggestedSlugs>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuggestedSlugs>>,
          TError,
          Awaited<ReturnType<typeof getSuggestedSlugs>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSuggestedSlugs<
  TData = Awaited<ReturnType<typeof getSuggestedSlugs>>,
  TError = ErrorType<unknown>,
>(
  params: GetSuggestedSlugsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuggestedSlugs>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSuggestedSlugs>>,
          TError,
          Awaited<ReturnType<typeof getSuggestedSlugs>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSuggestedSlugs<
  TData = Awaited<ReturnType<typeof getSuggestedSlugs>>,
  TError = ErrorType<unknown>,
>(
  params: GetSuggestedSlugsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuggestedSlugs>>, TError, TData>>;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Suggests slug names for a company/practice name.
 */

export function useGetSuggestedSlugs<
  TData = Awaited<ReturnType<typeof getSuggestedSlugs>>,
  TError = ErrorType<unknown>,
>(
  params: GetSuggestedSlugsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSuggestedSlugs>>, TError, TData>>;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetSuggestedSlugsQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetPlatformThemeBySubdomainUrl = (params?: GetPlatformThemeBySubdomainParams) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `https://admin.ageless.ai/api/v1/ageless/companies/search/platform/by-subdomain/theme?${stringifiedParams}`
    : `https://admin.ageless.ai/api/v1/ageless/companies/search/platform/by-subdomain/theme`;
};

/**
 * @summary Retrieves the active brand theme for a platform by subdomain.
Returns brand colors that can be used for white-labeling.
 */
export const getPlatformThemeBySubdomain = async (
  params?: GetPlatformThemeBySubdomainParams,
  options?: Parameters<typeof retrieveData>[1],
): Promise<DisplayPlatformTheme> => {
  return retrieveData<DisplayPlatformTheme>(getGetPlatformThemeBySubdomainUrl(params), {
    ...options,
    method: "GET",
  });
};

export const getGetPlatformThemeBySubdomainQueryKey = (
  params?: GetPlatformThemeBySubdomainParams,
) => {
  return [
    `https://admin.ageless.ai/api/v1/ageless/companies/search/platform/by-subdomain/theme`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetPlatformThemeBySubdomainQueryOptions = <
  TData = Awaited<ReturnType<typeof getPlatformThemeBySubdomain>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: GetPlatformThemeBySubdomainParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPlatformThemeBySubdomain>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPlatformThemeBySubdomainQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPlatformThemeBySubdomain>>> = ({
    signal,
  }) => getPlatformThemeBySubdomain(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPlatformThemeBySubdomain>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetPlatformThemeBySubdomainQueryResult = NonNullable<
  Awaited<ReturnType<typeof getPlatformThemeBySubdomain>>
>;
export type GetPlatformThemeBySubdomainQueryError = ErrorType<ProblemDetails>;

export function useGetPlatformThemeBySubdomain<
  TData = Awaited<ReturnType<typeof getPlatformThemeBySubdomain>>,
  TError = ErrorType<ProblemDetails>,
>(
  params: undefined | GetPlatformThemeBySubdomainParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPlatformThemeBySubdomain>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformThemeBySubdomain>>,
          TError,
          Awaited<ReturnType<typeof getPlatformThemeBySubdomain>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPlatformThemeBySubdomain<
  TData = Awaited<ReturnType<typeof getPlatformThemeBySubdomain>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: GetPlatformThemeBySubdomainParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPlatformThemeBySubdomain>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPlatformThemeBySubdomain>>,
          TError,
          Awaited<ReturnType<typeof getPlatformThemeBySubdomain>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetPlatformThemeBySubdomain<
  TData = Awaited<ReturnType<typeof getPlatformThemeBySubdomain>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: GetPlatformThemeBySubdomainParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPlatformThemeBySubdomain>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves the active brand theme for a platform by subdomain.
Returns brand colors that can be used for white-labeling.
 */

export function useGetPlatformThemeBySubdomain<
  TData = Awaited<ReturnType<typeof getPlatformThemeBySubdomain>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: GetPlatformThemeBySubdomainParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getPlatformThemeBySubdomain>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetPlatformThemeBySubdomainQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetIsPlatformOnboardedForAgelessUrl = (
  params?: GetIsPlatformOnboardedForAgelessParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `https://admin.ageless.ai/api/v1/ageless/companies/search/platform/is-onboarded-for-ageless?${stringifiedParams}`
    : `https://admin.ageless.ai/api/v1/ageless/companies/search/platform/is-onboarded-for-ageless`;
};

/**
 * @summary Retrieves whether a platform is onboarded for Ageless assessment flows.
Public-facing, returns only information safe for anonymous consumers.
 */
export const getIsPlatformOnboardedForAgeless = async (
  params?: GetIsPlatformOnboardedForAgelessParams,
  options?: Parameters<typeof retrieveData>[1],
): Promise<DisplayIsPlatformOnboardedForAgelessResponse> => {
  return retrieveData<DisplayIsPlatformOnboardedForAgelessResponse>(
    getGetIsPlatformOnboardedForAgelessUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetIsPlatformOnboardedForAgelessQueryKey = (
  params?: GetIsPlatformOnboardedForAgelessParams,
) => {
  return [
    `https://admin.ageless.ai/api/v1/ageless/companies/search/platform/is-onboarded-for-ageless`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetIsPlatformOnboardedForAgelessQueryOptions = <
  TData = Awaited<ReturnType<typeof getIsPlatformOnboardedForAgeless>>,
  TError = ErrorType<ProblemDetails | void>,
>(
  params?: GetIsPlatformOnboardedForAgelessParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getIsPlatformOnboardedForAgeless>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetIsPlatformOnboardedForAgelessQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getIsPlatformOnboardedForAgeless>>> = ({
    signal,
  }) => getIsPlatformOnboardedForAgeless(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getIsPlatformOnboardedForAgeless>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetIsPlatformOnboardedForAgelessQueryResult = NonNullable<
  Awaited<ReturnType<typeof getIsPlatformOnboardedForAgeless>>
>;
export type GetIsPlatformOnboardedForAgelessQueryError = ErrorType<ProblemDetails | void>;

export function useGetIsPlatformOnboardedForAgeless<
  TData = Awaited<ReturnType<typeof getIsPlatformOnboardedForAgeless>>,
  TError = ErrorType<ProblemDetails | void>,
>(
  params: undefined | GetIsPlatformOnboardedForAgelessParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getIsPlatformOnboardedForAgeless>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIsPlatformOnboardedForAgeless>>,
          TError,
          Awaited<ReturnType<typeof getIsPlatformOnboardedForAgeless>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetIsPlatformOnboardedForAgeless<
  TData = Awaited<ReturnType<typeof getIsPlatformOnboardedForAgeless>>,
  TError = ErrorType<ProblemDetails | void>,
>(
  params?: GetIsPlatformOnboardedForAgelessParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getIsPlatformOnboardedForAgeless>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getIsPlatformOnboardedForAgeless>>,
          TError,
          Awaited<ReturnType<typeof getIsPlatformOnboardedForAgeless>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetIsPlatformOnboardedForAgeless<
  TData = Awaited<ReturnType<typeof getIsPlatformOnboardedForAgeless>>,
  TError = ErrorType<ProblemDetails | void>,
>(
  params?: GetIsPlatformOnboardedForAgelessParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getIsPlatformOnboardedForAgeless>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves whether a platform is onboarded for Ageless assessment flows.
Public-facing, returns only information safe for anonymous consumers.
 */

export function useGetIsPlatformOnboardedForAgeless<
  TData = Awaited<ReturnType<typeof getIsPlatformOnboardedForAgeless>>,
  TError = ErrorType<ProblemDetails | void>,
>(
  params?: GetIsPlatformOnboardedForAgelessParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getIsPlatformOnboardedForAgeless>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetIsPlatformOnboardedForAgelessQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetAgelessProductOptionsForPlatformUrl = (
  params?: GetAgelessProductOptionsForPlatformParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `https://admin.ageless.ai/api/v1/ageless/companies/search/platform/product-options?${stringifiedParams}`
    : `https://admin.ageless.ai/api/v1/ageless/companies/search/platform/product-options`;
};

/**
 * @summary Retrieves the Ageless Leads product options configured for a platform.
Public-facing, returns only the product option flags safe for anonymous consumers.
 */
export const getAgelessProductOptionsForPlatform = async (
  params?: GetAgelessProductOptionsForPlatformParams,
  options?: Parameters<typeof retrieveData>[1],
): Promise<AgelessLeadsProductOptionResponse> => {
  return retrieveData<AgelessLeadsProductOptionResponse>(
    getGetAgelessProductOptionsForPlatformUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetAgelessProductOptionsForPlatformQueryKey = (
  params?: GetAgelessProductOptionsForPlatformParams,
) => {
  return [
    `https://admin.ageless.ai/api/v1/ageless/companies/search/platform/product-options`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAgelessProductOptionsForPlatformQueryOptions = <
  TData = Awaited<ReturnType<typeof getAgelessProductOptionsForPlatform>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: GetAgelessProductOptionsForPlatformParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAgelessProductOptionsForPlatform>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAgelessProductOptionsForPlatformQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgelessProductOptionsForPlatform>>> = ({
    signal,
  }) => getAgelessProductOptionsForPlatform(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAgelessProductOptionsForPlatform>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAgelessProductOptionsForPlatformQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAgelessProductOptionsForPlatform>>
>;
export type GetAgelessProductOptionsForPlatformQueryError = ErrorType<ProblemDetails>;

export function useGetAgelessProductOptionsForPlatform<
  TData = Awaited<ReturnType<typeof getAgelessProductOptionsForPlatform>>,
  TError = ErrorType<ProblemDetails>,
>(
  params: undefined | GetAgelessProductOptionsForPlatformParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAgelessProductOptionsForPlatform>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgelessProductOptionsForPlatform>>,
          TError,
          Awaited<ReturnType<typeof getAgelessProductOptionsForPlatform>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAgelessProductOptionsForPlatform<
  TData = Awaited<ReturnType<typeof getAgelessProductOptionsForPlatform>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: GetAgelessProductOptionsForPlatformParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAgelessProductOptionsForPlatform>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgelessProductOptionsForPlatform>>,
          TError,
          Awaited<ReturnType<typeof getAgelessProductOptionsForPlatform>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAgelessProductOptionsForPlatform<
  TData = Awaited<ReturnType<typeof getAgelessProductOptionsForPlatform>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: GetAgelessProductOptionsForPlatformParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAgelessProductOptionsForPlatform>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves the Ageless Leads product options configured for a platform.
Public-facing, returns only the product option flags safe for anonymous consumers.
 */

export function useGetAgelessProductOptionsForPlatform<
  TData = Awaited<ReturnType<typeof getAgelessProductOptionsForPlatform>>,
  TError = ErrorType<ProblemDetails>,
>(
  params?: GetAgelessProductOptionsForPlatformParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getAgelessProductOptionsForPlatform>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAgelessProductOptionsForPlatformQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetAgelessFlowAccessForPlatformUrl = (
  params?: GetAgelessFlowAccessForPlatformParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `https://admin.ageless.ai/api/v1/ageless/companies/search/platform/flow-access?${stringifiedParams}`
    : `https://admin.ageless.ai/api/v1/ageless/companies/search/platform/flow-access`;
};

/**
 * @summary Retrieves whether a specific Ageless assessment flow type is active for a platform,
based on Ageless Leads enabled state, product options, configured treatment capabilities,
and onboarding status.
 */
export const getAgelessFlowAccessForPlatform = async (
  params?: GetAgelessFlowAccessForPlatformParams,
  options?: Parameters<typeof retrieveData>[1],
): Promise<DisplayAgelessFlowAccessForPlatformResponse> => {
  return retrieveData<DisplayAgelessFlowAccessForPlatformResponse>(
    getGetAgelessFlowAccessForPlatformUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetAgelessFlowAccessForPlatformQueryKey = (
  params?: GetAgelessFlowAccessForPlatformParams,
) => {
  return [
    `https://admin.ageless.ai/api/v1/ageless/companies/search/platform/flow-access`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetAgelessFlowAccessForPlatformQueryOptions = <
  TData = Awaited<ReturnType<typeof getAgelessFlowAccessForPlatform>>,
  TError = ErrorType<ProblemDetails | void>,
>(
  params?: GetAgelessFlowAccessForPlatformParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAgelessFlowAccessForPlatform>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAgelessFlowAccessForPlatformQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgelessFlowAccessForPlatform>>> = ({
    signal,
  }) => getAgelessFlowAccessForPlatform(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAgelessFlowAccessForPlatform>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAgelessFlowAccessForPlatformQueryResult = NonNullable<
  Awaited<ReturnType<typeof getAgelessFlowAccessForPlatform>>
>;
export type GetAgelessFlowAccessForPlatformQueryError = ErrorType<ProblemDetails | void>;

export function useGetAgelessFlowAccessForPlatform<
  TData = Awaited<ReturnType<typeof getAgelessFlowAccessForPlatform>>,
  TError = ErrorType<ProblemDetails | void>,
>(
  params: undefined | GetAgelessFlowAccessForPlatformParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAgelessFlowAccessForPlatform>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgelessFlowAccessForPlatform>>,
          TError,
          Awaited<ReturnType<typeof getAgelessFlowAccessForPlatform>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAgelessFlowAccessForPlatform<
  TData = Awaited<ReturnType<typeof getAgelessFlowAccessForPlatform>>,
  TError = ErrorType<ProblemDetails | void>,
>(
  params?: GetAgelessFlowAccessForPlatformParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAgelessFlowAccessForPlatform>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAgelessFlowAccessForPlatform>>,
          TError,
          Awaited<ReturnType<typeof getAgelessFlowAccessForPlatform>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAgelessFlowAccessForPlatform<
  TData = Awaited<ReturnType<typeof getAgelessFlowAccessForPlatform>>,
  TError = ErrorType<ProblemDetails | void>,
>(
  params?: GetAgelessFlowAccessForPlatformParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAgelessFlowAccessForPlatform>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves whether a specific Ageless assessment flow type is active for a platform,
based on Ageless Leads enabled state, product options, configured treatment capabilities,
and onboarding status.
 */

export function useGetAgelessFlowAccessForPlatform<
  TData = Awaited<ReturnType<typeof getAgelessFlowAccessForPlatform>>,
  TError = ErrorType<ProblemDetails | void>,
>(
  params?: GetAgelessFlowAccessForPlatformParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getAgelessFlowAccessForPlatform>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAgelessFlowAccessForPlatformQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}

export const getGetEnabledAgelessFlowsForPlatformUrl = (
  params?: GetEnabledAgelessFlowsForPlatformParams,
) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? "null" : String(value));
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0
    ? `https://admin.ageless.ai/api/v1/ageless/companies/search/platform/enabled-flows?${stringifiedParams}`
    : `https://admin.ageless.ai/api/v1/ageless/companies/search/platform/enabled-flows`;
};

/**
 * @summary Retrieves which Ageless assessment flow types are currently active for a platform.
Each boolean reflects the combined result of Ageless Leads enabled state, onboarding,
product option, and capabilities checks.
 */
export const getEnabledAgelessFlowsForPlatform = async (
  params?: GetEnabledAgelessFlowsForPlatformParams,
  options?: Parameters<typeof retrieveData>[1],
): Promise<DisplayEnabledAgelessFlowsForPlatformResponse> => {
  return retrieveData<DisplayEnabledAgelessFlowsForPlatformResponse>(
    getGetEnabledAgelessFlowsForPlatformUrl(params),
    {
      ...options,
      method: "GET",
    },
  );
};

export const getGetEnabledAgelessFlowsForPlatformQueryKey = (
  params?: GetEnabledAgelessFlowsForPlatformParams,
) => {
  return [
    `https://admin.ageless.ai/api/v1/ageless/companies/search/platform/enabled-flows`,
    ...(params ? [params] : []),
  ] as const;
};

export const getGetEnabledAgelessFlowsForPlatformQueryOptions = <
  TData = Awaited<ReturnType<typeof getEnabledAgelessFlowsForPlatform>>,
  TError = ErrorType<ProblemDetails | void>,
>(
  params?: GetEnabledAgelessFlowsForPlatformParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEnabledAgelessFlowsForPlatform>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEnabledAgelessFlowsForPlatformQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEnabledAgelessFlowsForPlatform>>> = ({
    signal,
  }) => getEnabledAgelessFlowsForPlatform(params, { signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEnabledAgelessFlowsForPlatform>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEnabledAgelessFlowsForPlatformQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEnabledAgelessFlowsForPlatform>>
>;
export type GetEnabledAgelessFlowsForPlatformQueryError = ErrorType<ProblemDetails | void>;

export function useGetEnabledAgelessFlowsForPlatform<
  TData = Awaited<ReturnType<typeof getEnabledAgelessFlowsForPlatform>>,
  TError = ErrorType<ProblemDetails | void>,
>(
  params: undefined | GetEnabledAgelessFlowsForPlatformParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEnabledAgelessFlowsForPlatform>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEnabledAgelessFlowsForPlatform>>,
          TError,
          Awaited<ReturnType<typeof getEnabledAgelessFlowsForPlatform>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEnabledAgelessFlowsForPlatform<
  TData = Awaited<ReturnType<typeof getEnabledAgelessFlowsForPlatform>>,
  TError = ErrorType<ProblemDetails | void>,
>(
  params?: GetEnabledAgelessFlowsForPlatformParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEnabledAgelessFlowsForPlatform>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEnabledAgelessFlowsForPlatform>>,
          TError,
          Awaited<ReturnType<typeof getEnabledAgelessFlowsForPlatform>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEnabledAgelessFlowsForPlatform<
  TData = Awaited<ReturnType<typeof getEnabledAgelessFlowsForPlatform>>,
  TError = ErrorType<ProblemDetails | void>,
>(
  params?: GetEnabledAgelessFlowsForPlatformParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEnabledAgelessFlowsForPlatform>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Retrieves which Ageless assessment flow types are currently active for a platform.
Each boolean reflects the combined result of Ageless Leads enabled state, onboarding,
product option, and capabilities checks.
 */

export function useGetEnabledAgelessFlowsForPlatform<
  TData = Awaited<ReturnType<typeof getEnabledAgelessFlowsForPlatform>>,
  TError = ErrorType<ProblemDetails | void>,
>(
  params?: GetEnabledAgelessFlowsForPlatformParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEnabledAgelessFlowsForPlatform>>, TError, TData>
    >;
    request?: SecondParameter<typeof retrieveData>;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEnabledAgelessFlowsForPlatformQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return withQueryKey(query, queryOptions.queryKey);
}
